import clsx from "clsx";

import { useColorScheme } from "hooks/useColorScheme";
import useDeviceType from "hooks/useDeviceType";
import { IPaymentProfile } from "models/HaulPay";
import styles from "./style.module.scss";

interface IProps {
  isSelected?: boolean;
  data: IPaymentProfile;
  onSelectProfile: VoidFunction;
}

export default function PaymentProfileItem({
  isSelected = false,
  data,
  onSelectProfile
}: Readonly<IProps>) {
  const { isDesktop } = useDeviceType();
  const { currentIsDark } = useColorScheme();

  return (
    <>
      {isDesktop ? (
        <a
          href="#"
          tabIndex={0}
          className={clsx(
            styles.addNewDesktopContainer,
            !currentIsDark && "drop-shadow-[0_2px_4.5px_#9E9E9E33]",
            { "!border-primary": isSelected }
          )}
          onClick={(e) => {
            e.preventDefault();
            onSelectProfile();
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter") onSelectProfile();
          }}>
          <button type="button" className={styles.connectButton} onClick={onSelectProfile}>
            {data.is_connected ? "CONNECTED" : "NOT CONNECTED"}
          </button>

          <ul className={styles.cardList}>
            <li>
              <span className="font-semibold">{`${data.owner_name_first} ${data.owner_name_last}`}</span>
              <span>{data.owner_email}</span>
            </li>
            <li>
              <span className="text-subtitle">Phone</span>
              <span>{data.owner_phone_number_cell}</span>
            </li>
            <li>
              <span className="text-subtitle">MC#</span>
              <span>{data.company_mc}</span>
            </li>
            <li>
              <span className="text-subtitle">Company</span>
              <span>{data.company_name}</span>
            </li>
            <li>
              <span className="text-subtitle">Status</span>
              <span className={data.status === "approved" ? "text-success" : "text-pendingBorder"}>
                {data.status === "approved" ? "Approved" : "Needs Review"}
              </span>
            </li>
          </ul>
        </a>
      ) : (
        <div className={clsx(styles.addNewItemContainer, { "bg-foreground": isSelected })}>
          <span>{`${data.owner_name_first} ${data.owner_name_last}`}</span>
          <div className="flex justify-between">
            <div>
              <span>Status: </span>
              {data.status === "review" ? (
                <span className="text-primary">Needs Review</span>
              ) : (
                <span className="text-success">Approved</span>
              )}
            </div>
            <button type="button" className="underline text-primary" onClick={onSelectProfile}>
              {data.is_connected ? "CONNECTED" : "NOT CONNECTED"}
            </button>
          </div>

          <div className="pt-2">
            <span>{`MC# ${data.company_mc}`}</span>
            <div className="flex justify-between gap-x-2">
              <span>{data.owner_email}</span>
              <span className="text-right text-placeholder">{data.company_name}</span>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
